<template>
  <div
    v-if="showContentLoader"
    class="loader-wrapper"
  >
    <tiny-loader
      class="loader-class"
      variant="secondary"
    />
  </div>
  <div
    v-else
    class="signup"
  >
    <Descope
      :client="{ anonymousUserId: anonymousSession.getId(), utmParams, contextPageReferrer }"
      :error-transformer="errorTransformer"
      flow-id="il-login"
      @error="handleDescopeError"
    />
  </div>
</template>

<script lang="ts" setup>
import { Descope, useSession } from '@descope/vue-sdk';
import TinyLoader from '@riseupil/base-ui/src/components/TinyLoader/TinyLoader.vue';
import _ from 'lodash';
import { onBeforeMount, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Segment from '../../../Segment';
import anonymousSession from '../../../anonymousSession';
import useContentLoader from '../../../composables/useContentLoader';
import { errorTransformer, handleDescopeError } from '../../../utils/errorHandling';

const router = useRouter();
const {
  toggleLoader, showContentLoader,
} = useContentLoader();
toggleLoader(true);
watch(useSession().isLoading, async newVal => {
  toggleLoader(newVal);
});

const utmParams = _.pickBy(router.currentRoute.value.query, (value, key) => (key.startsWith('utm_') && value));
const contextPageReferrer = document.referrer;
const route = useRoute();

onBeforeMount(async () => {
  const queryParam = route.query || null;
  if (!queryParam['descope-login-flow']) {
    await Segment.reset();
    Segment.identifyAnonymousUser();
  }
});

const onMetaBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (userAgent.indexOf('FBAN') > -1) || (userAgent.indexOf('FBAV') > -1) || (userAgent.indexOf('Instagram') > -1);
};

const currentHash = window.location.hash;

if (onMetaBrowser() && !currentHash) {
  window.location.hash = '#FBK';
}

</script>

<style lang="scss" scoped>
@import '../../../scss/riseup-vars';

.signup {
  overflow-y: auto;
  scroll-behavior: smooth;
  background-color: #FFFFFF;
}

.loader-wrapper {
  background-color: #EEF2F8;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

</style>
